import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 * Only updates elements with data-hydration-key attribute. This ensures that non-targeted nodes do not have their markup/state updated unnecessarily.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false, url, mode: 'hydration' });

  section.dataset.hydrated = 'true';

 // === UPLOAD-LIFT FIX START ===
  try {
    // 1. Try the standard global init if available
    if (window.UploadLift && typeof window.UploadLift.init === 'function') {
      window.UploadLift.init();
    }
    
    // 2. Dispatch a standard Shopify theme variant/DOM change event 
    // Many apps automatically listen for these to refresh themselves
    document.dispatchEvent(new CustomEvent('page:loaded'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    window.dispatchEvent(new Event('resize')); // Forces some apps to recalculate positions
    
    // 3. Fallback if the script asset loads late
    document.addEventListener('uploadlift:ready', () => {
      if (typeof window.UploadLift.init === 'function') {
        window.UploadLift.init();
      }
    });
  } catch (error) {
    console.warn('Upload-Lift re-initialization failed:', error);
  }
  // === UPLOAD-LIFT FIX END ===
}

/**
 * Hydrates a section using the Section Rendering API preserving states, when
 * the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}